module.exports = __webpack_public_path__ + "static/media/ZGO__i3_sm1.81788b21.png";